import { defaultCurrencyConfig, defaultNumberConfig } from '@vista-digital/i18n';
import { Validator } from '@vista-digital/validator';
import { currencyConfigValidator } from '../../../../../validators/currency-config';
import { numberConfigValidator } from '../../../../../validators/number-config';
import { defaultOccDateConfig, occDateConfigValidator } from './date';
import { defaultOccPersonNameConfig, occPersonNameConfigValidator } from './person-name';
export const defaultOccLocaleConfig = {
    currency: defaultCurrencyConfig,
    number: defaultNumberConfig,
    date: defaultOccDateConfig,
    personName: defaultOccPersonNameConfig
};
export const occLocaleConfigValidator = Validator.object({
    currency: currencyConfigValidator,
    number: numberConfigValidator,
    date: occDateConfigValidator,
    personName: occPersonNameConfigValidator
});
//# sourceMappingURL=locale.js.map